import { useCallback, useRef, useState } from 'react';
import useOutsideClick from '../../../../../../../hook/useOutsideClick';
import { deleteScheduledTaskModal } from '../../../../../../../services/cna/scheduled-tasks';
import { formatTaskPeriodSettings } from '../../../../../../../utility';
import { isResponseOk } from '../../../../../../../utility/isResponseOk';
import DeleteTaskModal from '../../delete-task-modal';
import EditTaskModal from './EditTaskModal';

const ScheduledTaskExtraTaskCols = ({ task, index, targetType, assignmentId, getScheduledTasks, handleGetAssignment }) => {
  const dropdownRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEditTaskModalOpen, setIsEditTaskModalOpen] = useState(false);
  const [isDeleteTaskModalOpen, setIsDeleteTaskModalOpen] = useState(false);

  useOutsideClick(dropdownRef, () => setIsDropdownOpen(false));

  const handleDeleteTask = useCallback(async () => {
    try {
      const data = {
        assignmentId,
        taskID: task.id,
      };

      const res = await deleteScheduledTaskModal(data);
      if (isResponseOk(res)) {
        setIsDeleteTaskModalOpen(false);
        getScheduledTasks();
        handleGetAssignment();
      }
    } catch (e) {
      console.error(e);
    }
  }, [task]);

  return (
    <>
      <td className="task-name-col">
        {index + 1}. {task.default_task ? task.default_task.text : task.text}
      </td>
      <td className="shifts-col">{task.period_settings?.shift_types?.map((shift) => shift.replace('_', '-')).join(', ')}</td>
      <td className="period-col">{formatTaskPeriodSettings(task.period_settings)}</td>
      <td className="action-col">
        {!task.is_transfer_status_related && !task.is_status_of_continent_related && (
          <div className="dropdown" ref={dropdownRef}>
            <button onClick={() => setIsDropdownOpen(true)} className="btn btn-outline">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                  fill="#667085"
                />
                <path
                  d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                  fill="#667085"
                />
                <path
                  d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                  fill="#667085"
                />
                <path
                  d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                  stroke="#667085"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                  stroke="#667085"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                  stroke="#667085"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            {isDropdownOpen && (
              <ul className="dropdown-menu">
                <li>
                  <button className="btn btn-left btn-full btn-text" onClick={() => setIsEditTaskModalOpen(true)}>
                    <i className="icon-icon-edit mr-2"></i>Edit Task
                  </button>
                </li>
                <li>
                  <button className="btn btn-left btn-full btn-danger btn-text" onClick={() => setIsDeleteTaskModalOpen(true)}>
                    <i className="icon-remove mr-2" />
                    Delete Task
                  </button>
                </li>
              </ul>
            )}
          </div>
        )}
      </td>
      {isEditTaskModalOpen && (
        <EditTaskModal
          onClose={() => setIsEditTaskModalOpen(false)}
          handleGetAssignment={handleGetAssignment}
          getScheduledTasks={getScheduledTasks}
          taskData={{ ...task, targetType }}
          assignmentId={assignmentId}
        />
      )}
      {isDeleteTaskModalOpen && <DeleteTaskModal handleConfirm={handleDeleteTask} closeModal={() => setIsDeleteTaskModalOpen(false)} />}
    </>
  );
};

export default ScheduledTaskExtraTaskCols;
